<template>
  <div class="tableWrap">
    <el-table
      class="table"
      :data="tableData"
      stripe
      style="width: 100%"
      :height="TableHeight"
      @selection-change="selectChange"
    >
      <!--      @selection-change="selectChange"-->
      <!-- 单选 || 多选 -->
      <el-table-column
        v-if="ISChangeCheckout"
        width="40"
        :render-header="renderHeader"
      >
        <template slot-scope="scope">
          <el-checkbox
            :label="scope.row"
            v-show="btnControl({emitName: 'delete'}, scope.row)"
            v-model="selectData"
            @change="selectChange(selectData)">
            &nbsp;&nbsp;
          </el-checkbox>
        </template>
      </el-table-column>
      <!-- 展开行 -->
      <el-table-column type="expand" width="40" v-if="canExpand">
        <template slot-scope="props">
          <el-form label-position="left" class="n-table-expand">
            <el-form-item label="标题">
              <span>{{ props.row.taskName }}</span>
            </el-form-item>
            <el-form-item label="题干">
              <span v-html="props.row.questionContent"></span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <!-- 自然th -->
      <el-table-column
        v-for="item in tableHeader"
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
        :width="item.width || 'auto'"
        :fixed="item.fixed ? item.fixed : false"
        :show-overflow-tooltip="item.showOverflow ? item.showOverflow : false"
        :align="item.align ? item.align : 'left'"
        :sortable="!!item.sortable"
        :sort-method="(a, b) => sortMethod(a, b, item.prop)"
      >
        <!-- :sort-orders="['ascending', 'descending', null]" -->
        <template slot-scope="scope">
          <div
            v-if="
              item.prop != 'taskName' &&
              item.prop != 'operation' &&
              item.prop != 'difficulty' &&
              item.prop != 'totalTime' &&
              item.prop != 'paperType'
            "
            :title="scope.row[item.prop]"
            v-text="scope.row[item.prop]"
          ></div>
          <!-- html结构 -->
          <div v-if="item.prop == 'taskName'">
            <div
              class="question_title"
              v-html="scope.row.taskName"
            ></div>
          </div>
          <!-- 试题难度 -->
          <div v-if="item.prop == 'difficulty'">
            {{
              scope.row.difficulty == 1
                ? "简单"
                : scope.row.difficulty == 2
                  ? "中等"
                  : scope.row.difficulty == 3
                    ? "困难"
                    : ""
            }}
          </div>
          <!-- 考试时长 -->
          <div v-if="item.prop == 'totalTime'">
            {{ scope.row.totalTime ? scope.row.totalTime : "--" }}
          </div>
          <!-- 操作btn -->
          <div v-else-if="item.prop == 'operation'">
            <!--   0!=  1== 2<= 3>=    -->
            <el-button
              v-for="bs in item.SlotType.buttons"
              v-show="btnControl(bs,scope.row )"
              :key="bs.emitName"
              @click="$emit('operation', bs.emitName, scope.row)"
              :type="bs.buttonType ? bs.buttonType : 'primary'"
              :style="bs.buttonStyle ? bs.buttonStyle : {}"
              size="mini"
              v-text="bs.name"
              :disabled="
                bs.isDisabled && scope.row[bs.isDisabled[0]] == bs.isDisabled[1]
              "
            ></el-button>
          </div>
          <!-- 用途 -->
          <div class="paperTypeGroup" v-if="item.prop == 'paperType'">
            <!--<template v-for="item in scope.row.paperType">
              <span v-if="item === 1">考试</span>
              <span v-if="item === 2">测验</span>
              <span v-if="item === 3">大赛</span>
              <span v-if="item === 4">综合实训</span>
              <span v-if="item === 5">大赛练习</span>
              <span v-if="item === 6">技能测评</span>
            </template>-->
            <span
              :style="{
                '--color': scope.row.paperType === 1 ? '#ffa85a' : '#3FC799',
                '--bgcolor':
                  scope.row.paperType === 1
                    ? 'rgba(255, 168, 90, 0.11)'
                    : 'rgba(63, 199, 153, 0.11)',
              }"
            >{{ scope.row.paperType | filterStatus }}</span
            >
          </div>
        </template>
      </el-table-column>
      <!-- null 列表 -->
      <div slot="empty" class="empty_material">
        <img src="@/assets/image/sources/table_no_data.png" alt="加载失败"/>
        <p>暂无数据</p>
      </div>
    </el-table>
  </div>
</template>
<script>
export default {
  name: "n_table",
  data() {
    return {
      dialogVisible: false, //删除的弹框
      sceneId: "", //计划中的考试时间id
      subjectId: "", //计划的考试时间中的科目id
      selectData: [],

      //
      indeterminate: false,
      isCheck: false,
    };
  },
  props: {
    tableData: {
      // 表格数据
      type: [Array],
      default: function () {
        return [];
      },
    },
    tableHeader: {
      // 表格头部
      type: [Array, Object],
      default: function () {
        return [];
      },
    },
    TableHeight: {
      // 表格高度
      type: [String],
      default: "100%",
    },
    // 隐藏或展示一些东西
    form: {
      type: String,
      default: "",
    },
    ISChangeCheckout: {
      // 是否显示 checkout
      type: [Boolean],
      default: true,
    },
    paperFrom: {  // 试卷来源 （0：资源库的试卷库，1：教学中的班级，2：教学的课程）
      type: String,
      default: null,
    },
    canExpand: {
      // 是否显示 展开行
      type: [Boolean],
      default: false,
    },
  },
  methods: {
    /* 按钮权限，展示与影藏控制 */
    btnControl(bs, row) {


      let isShow = bs.isShow
        ? bs.isShow[1] == 0
          ? row[bs.isShow[0]] != bs.isShow[2]
            ? true
            : false
          : bs.isShow[1] == 1
            ? row[bs.isShow[0]] == bs.isShow[2]
              ? true
              : false
            : bs.isShow[1] == 2
              ? row[bs.isShow[0]] <= bs.isShow[2]
                ? true
                : false
              : bs.isShow[1] == 3
                ? row[bs.isShow[0]] >= bs.isShow[2]
                  ? true
                  : false
                : false
        : true;
      // if ( bs.isShow ){
      //   if (bs.isShow[1] == 0 && row[bs.isShow[0]] == bs.isShow[2]){
      //     isShow = false;
      //   }
      //   else if (bs.isShow[1] == 1 && row[bs.isShow[0]] == bs.isShow[2]){
      //     isShow = false;
      //   }
      //   else if (bs.isShow[1] == 2 && row[bs.isShow[0]] <= bs.isShow[2]){
      //     isShow = false;
      //   }
      //   else if (bs.isShow[1] == 3 && row[bs.isShow[0]] >= bs.isShow[2]){
      //     isShow = false;
      //   }
      // }

      /**
       *   单独处理班级里展示试卷列表
       *   wjl 2022.11.11
       *   试卷创建来源 （0：资源库的试卷，1：班级中的试卷，2：课程中的试卷）
       *   如果是班级中创建的试卷，又传入组件中paperFrom == 1
       *   说明要控制按钮，编辑和删除只展示在班级创建的试卷上
       */
      if (this.paperFrom == 1) {
        if (this.paperFrom == row.paperFrom) {
          return true
        } else if (bs.emitName === 'edit' || bs.emitName === 'delete' || bs.emitName === 'copy') {
          return false
        } else {
          return true
        }
      } else if(this.paperFrom == 2){
          return (bs.emitName === 'edit' && row['isAuth'] === 1 || bs.emitName === 'copy' && row['isAuth'] === 1) || bs.emitName !== 'edit' && bs.emitName !== 'copy'
      }
      else {
        return isShow
      }
    },
    sortMethod(row1, row2, prop) {
      let res = 0;
      let str1 = row1[prop];
      let str2 = row2[prop];
      if (typeof str1 === "number" && typeof str1 === "number") {
        // 数字类型直接比较
        return str1 - str2;
      }

      if (str1 === null) {
        str1 = "";
      }
      if (str2 === null) {
        str2 = "";
      }
      for (let i = 0; ; i++) {
        if (!str1[i] || !str2[i]) {
          res = str1.length - str2.length;
          break;
        }
        const char1 = str1[i];
        const char1Type = this.getChartType(char1);
        const char2 = str2[i];
        const char2Type = this.getChartType(char2);
        // 类型相同的逐个比较字符
        if (char1Type[0] === char2Type[0]) {
          if (char1 === char2) {
            continue;
          } else {
            if (char1Type[0] === "zh") {
              res = char1.localeCompare(char2);
            } else if (char1Type[0] === "en") {
              res = char1.charCodeAt(0) - char2.charCodeAt(0);
            } else {
              res = char1 - char2;
            }
            break;
          }
        } else {
          // 类型不同的，直接用返回的数字相减
          res = char1Type[1] - char2Type[1];
          break;
        }
      }
      return res;
    },
    getChartType(char) {
      // 数字可按照排序的要求进行自定义
      // 数字（0->9）->大写字母（A->Z）->小写字母（a->z）->中文拼音（a->z）
      if (/^[\u4e00-\u9fa5]$/.test(char)) {
        return ["zh", 300];
      }
      if (/^[a-zA-Z]$/.test(char)) {
        return ["en", 200];
      }
      if (/^[0-9]$/.test(char)) {
        return ["number", 100];
      }
      return ["others", 999];
    },
    selectChange(data) {

      // 当在班级中展示试卷this.paperFrom == 1
      // 筛选出列表中在班级里创建的试卷 row.paperFrom : 1;
      // 选中项按照真实的试卷量，判断全选状态
      if (this.paperFrom == 1) {
        let realLength = 0;
        this.tableData.forEach(item => {
          if (item.paperFrom == 1) realLength++
        })
        this.indeterminate = data.length > 0 && data.length < realLength; // 中间状态
        this.isCheck = data.length === realLength   // 全选状态
      } else {
        this.isCheck = data.length === this.tableData.length
        this.indeterminate = data.length > 0 && data.length < this.tableData.length;
      }

      this.$emit("operation", "selectChange", data);
    },
    /* 自定义复选框 */
    renderHeader(h, data) {
      return h("span", [
        h("el-checkbox", {
          on: {
            change: this.selectBox
          },
          props: {
            value: this.isCheck,
            indeterminate: this.indeterminate
          }
        })
      ]);
    },
    selectBox() {
      this.isCheck = !this.isCheck;
      if (this.isCheck) {
        // 当在班级中展示试卷this.paperFrom == 1
        // 筛选出列表中在班级里创建的试卷 row.paperFrom : 1;
        // 选中项按照真实的试卷量，判断全选状态
        this.indeterminate = false;
        if (this.paperFrom == 1) {
          let realLength = [];
          this.tableData.forEach(item => {
            if (item.paperFrom == 1) realLength.push(item)
          })
          this.selectData = realLength;
        } else {
          this.selectData = this.tableData;
        }

      } else {
        this.selectData = [];
      }
      this.$emit("operation", "selectChange", this.selectData);
    },
    ClearData(){
      this.selectData = []
      this.isCheck = false
      this.indeterminate = false
    },
  },
  filters: {
    filterStatus(paperType) {
      let str = "";
      switch (paperType) {
        case 1:
          str = "考试";
          break;
        case 2:
          str = "测验";
          break;
        case 3:
          str = "大赛";
          break;
        case 4:
          str = "综合实训";
          break;
        case 5:
          str = "大赛练习";
          break;
        case 6:
          str = "技能测评";
          break;
      }
      return str;
    },
  },
};
</script>
<style scoped lang="scss">
.table {
  margin-top: 8px;
  border-top: 1px solid #ededf0;

  .empty_material {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    img {
      width: 187px;
      height: 159px;
    }

    p {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #767484;
      margin: 0;
    }
  }

  /deep/ .el-table__header-wrapper .cell {
    color: #767484;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  /deep/ .el-table__row {
    background: #f5f5f7;
  }

  /deep/ .el-table__row--striped {
    background: #fff;
  }

  /deep/ .el-table__body-wrapper .cell {
    color: #0f0d11;
    font-size: 12px;
  }

  .el-button {
    color: #1890ff;
    font-size: 12px;
    margin: 0px;
    margin-right: 10px;
  }

  .table_delete_btn {
    color: #1890ff;
    font-size: 12px;
  }

  /deep/ .question_title {
    line-height: 39px;
    height: 39px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    img {
      display: none;
    }
  }

  /deep/ .question_title * {
    font-size: 12px !important;
    color: #262628 !important;
    font-weight: 400 !important;
    font-style: inherit !important;
    text-decoration: inherit !important;
  }

  /deep/ .is-disabled {
    color: #767484;
  }

  .paperTypeGroup {
    span {
      display: inline-block;
      width: 30px;
      height: 18px;
      margin-right: 5px;
      line-height: 18px;
      text-align: center;
      color: var(--color);
      background-color: var(--bgcolor);
      border-radius: 2px;
      // &:nth-child(1) {
      //   color: #ffa85a;
      //   background-color: rgba(255, 168, 90, 0.11);
      // }
      // &:nth-child(2) {
      //   color: #3FC799;
      //   background-color: rgba(63, 199, 153, 0.11);
      // }
    }
  }

  /deep/ .n-table-expand {
    font-size: 0;
  }
  /deep/ .n-table-expand label {
    width: 90px;
    color: #99a9bf;
    text-align: center;
    font-size: 12px;
  }
  /deep/ .n-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;

    .el-form-item__content {
      font-size: 12px;
    }
  }
}

/deep/ .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fff;
}

/deep/ .is-left {
  text-align: left !important;
}

/deep/ .el-tooltip > div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/deep/ .el-table td,
/deep/ .el-table th {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/components/n_table.vue